<template>
    <div id="dashboardInspection">
        <div class="headerContent">
            <div class="headerLeft">
                <div class="headerBtn" style="margin-right: 12px" @click="()=>{this.$router.push({path:'/index'})}">返回</div>
            </div>
            <div class="headerMiddle">
                巡检系统
            </div>
            <div class="headerRight">
                {{ timeInfo.currentTime }}&nbsp; {{ timeInfo.date }} &nbsp;{{ timeInfo.weekday }}
            </div>
        </div>
        <div class="contentWrap">
            <div class="leftContent">
                <div class="contentItem">
                    <div class="labelContainer">
                        <div class="imgContainer">
                            <div v-if="team" >
                                <img src="../../assets/img/dashboard/team_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/team_normal.png" alt="">
                            </div>
                        </div>
                        <div class="imgContainer">
                            <div v-if="live" >
                                <img src="../../assets/img/dashboard/live_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/live_normal.png" alt="">
                            </div>
                        </div>
                        <div class="imgContainer">
                            <div v-if="mapMark" >
                                <img src="../../assets/img/dashboard/map_mark_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/map_mark_normal.png" alt="">
                            </div>
                        </div>
                        <div class="imgContainer">
                            <div v-if="airLine" >
                                <img src="../../assets/img/dashboard/airline_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/airline_normal.png" alt="">
                            </div>
                        </div>
                        <div class="imgContainer">
                            <div v-if="plan" >
                                <img src="../../assets/img/dashboard/plan_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/plan_normal.png" alt="">
                            </div>
                        </div>
                        <div class="imgContainer">
                            <div v-if="media" >
                                <img src="../../assets/img/dashboard/media_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/media-normal.png" alt="">
                            </div>
                        </div>
                        <div class="imgContainer">
                            <div v-if="AI" >
                                <img src="../../assets/img/dashboard/AI_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/AI_normal.png" alt="">
                            </div>
                        </div>
                        <div class="imgContainer">
                            <div v-if="flyRecords" >
                                <img src="../../assets/img/dashboard/fly_records_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/fly_records_normal.png" alt="">
                            </div>
                        </div>
                        <div class="imgContainer">
                            <div v-if="flyArea" >
                                <img src="../../assets/img/dashboard/fly_area_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/fky_area_normal.png" alt="">
                            </div>
                        </div>
                        <div class="imgContainer">
                            <div v-if="data" >
                                <img src="../../assets/img/dashboard/data_analyze_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/data_analyze_normal.png" alt="">
                            </div>
                        </div>
                        <div class="lastImgContainer" >
                            <div v-if="home" >
                                <img src="../../assets/img/dashboard/home_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/home_normal.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contentItem">
                    <div class="infoContainer">
                        <div class="titleContainer">
                            <div class="title">无人机智能巡检系统</div>
                            <div class="user">admin</div>
                        </div>
                        <div class="airPortContainer">
                            <div class="airport">
                                <div class="txt">机场</div>
                                <div class="data">
                                    <div class="num">1</div>
                                    <div class="icon">
                                    </div>
                                </div>
                            </div>
                            <div class="equipment">
                                <div class="state">
                                    <div class="txt" style="  width: 228px;
                                    height: 35px;line-height: 35px;margin-left: 14px;">DJI Dock2-M3TD</div>
                                    <div class="stateOne">
                                        <img src="../../assets/img/dashboard/she_bei.png" style="width: 20px;height: 20px;" alt="">
                                        <div class="span">设备空闲中</div>
                                    </div>
                                    <div class="stateTwo">
                                        <img src="../../assets/img/dashboard/ji_cang.png" style="width: 20px;height: 20px;" alt="">
                                        <div class="span">舱内关机</div>
                                    </div>
                                </div>
                                <div class="imgs">
                                   <div class="img-container" >
                                     <img src="../../assets/img/dashboard/yan_jing.png"  style="width: 24px;height: 24px;" alt="">
                                   </div>
                                </div>
                            </div>


                        </div>
                        <div class="onlineEquipment">
                            <div class="airport">
                                <div class="txt">在线设备</div>
                                <div class="data">
                                    <div class="num">0</div>
                                    <div class="icon">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="internationalEquipmkent">
                            <div class="airport">
                                <div class="txt">国际设备</div>
                                <div class="data">
                                    <div class="num">0</div>
                                    <div class="icon">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rightIconContainer">
              <div class="iconContainer">
                   <div class="topIconContainer">
                        <div class="top">
                            <div v-if="straight" >
                                <img src="../../assets/img/dashboard/straight_line_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/straight_line_normal.png" alt="">
                            </div>
                        </div>
                        <div class="top">
                            <div v-if="square" >
                                <img src="../../assets/img/dashboard/straight_line_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/square_normal.png" alt="">
                            </div>
                        </div>
                   </div>
                   <div class="bottomIconContainer">
                    <div class="top">
                            <div v-if="clear" >
                                <img src="../../assets/img/dashboard/clear_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/clear_normal.png" alt="">
                            </div>
                        </div>
                        <div class="top">
                            <div v-if="mark5" >
                                <img src="../../assets/img/dashboard/mark5_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/mark5_normal.png" alt="">
                            </div>
                        </div>
                        <div class="top">
                            <div v-if="mark4" >
                                <img src="../../assets/img/dashboard/mark4_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/mark4_onrmal.png" alt="">
                            </div>
                        </div>
                        <div class="top">
                            <div v-if="mark3" >
                                <img src="../../assets/img/dashboard/mark3_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/mark3_normal.png" alt="">
                            </div>
                        </div>
                        <div class="top">
                            <div v-if="mark2" >
                                <img src="../../assets/img/dashboard/mark2_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/mark2_normal.png" alt="">
                            </div>
                        </div>
                        <div class="top">
                            <div v-if="mark1" >
                                <img src="../../assets/img/dashboard/mark1_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/mark1_normal.png" alt="">
                            </div>
                        </div>
                        <div class="top">
                            <div v-if="circle" >
                                <img src="../../assets/img/dashboard/circle_click.png" alt="">
                            </div>
                            <div v-else>
                                <img src="../../assets/img/dashboard/circle_normal.png" alt="">
                            </div>
                        </div>
                   </div>
              </div>
            </div>
            <div class="rightContent">
              <div class="contentItem">
                <div class="itemTitle">
                  <div class="itemTitleText">巡检历史统计</div>
                </div>
                <div class="inspectionContentWrap">
                  <div  id="patrolHistory">
                      <div class="historyItem"  >
                        <div class="data" >2160</div>
                        <div class="text">历史巡检</div>
                      </div>
                      <div class="historyItem">
                        <div class="data">2160</div>
                        <div class="text">当日巡检</div>
                      </div>
                      <div class="historyItem" style="border-right: none;">
                        <div class="data">2160</div>
                        <div class="text">当日待巡检</div>
                      </div>
                  </div>
                  <div id="rightTopChart" class="lineChartWrap"></div>
                </div>
              </div>
              <div class="contentItem">
                <div class="itemTitle">
                  <div class="itemTitleText">巡检当日统计</div>
                </div>
                <div class="inspectionContentWrap">
                  <div  id="patrolDefect">
                      <div class="dayItem fa-mouse-pointer" style="padding-left: 0;padding-top: 5px;padding-bottom: 5px;" @click="changeChartType('day')" >
                        <div  :class="chartType==='day'?'checkData':'data'" >600</div>
                        <div class="text">巡检天数</div>
                      </div>
                      <div class="dayItem separate fa-mouse-pointer" @click="changeChartType('frequency')" style="margin-left: 5px">
                        <div  :class="chartType==='frequency'?'checkData':'data'">2160</div>
                        <div class="text">巡检架次</div>
                      </div>
                      <div class="dayItem fa-mouse-pointer" style="border-right: none;" @click="changeChartType('mileage')">
                        <div  :class="chartType==='mileage'?'checkData':'data'">2160</div>
                        <div class="text">巡检里程</div>
                      </div>
                  </div>
                <div id="rightCenterChart"  class="lineChartWrap" ></div>
              </div>
              </div>
              <div class="contentItem">
                <div class="itemTitle">
                  <div class="itemTitleText">巡检缺陷统计</div>
                </div>
                <div class="barChart" id="rightBottomChart"></div>
              </div>
            </div>
        </div>
    </div>
</template>
<script >
import echarts from "echarts";
export default {
  name: "inspection",
  data() {
    return {
      timeInfo: {
        currentTime: "10:04:06",
        date: "2020-10-20",
        weekday: "星期一"
      },
      team:true,
      chartType:'day',
      live:false,
      mapMark:false,
      airLine:false,
      plan:false,
      media:false,
      AI:false,
      flyRecords:false,
      flyArea:false,
      data:false,
      home:false,
      straight:false,
      square:false,
      clear:false,
      mark5:false,
      mark4:false,
      mark3:false,
      mark2:false,
      mark1:false,
      circle:false,
      rightBottom:null,
      rightBottomData:[],
      rightTop:null,
      rightTopData:[],
      rightCenter:null,
      rightCenterData:[],
    };
  },
  mounted() {
    this.setTime();
    this.getPageData()
    window.addEventListener('resize', this.handleResize, {passive: true});
    window.timer = setInterval(this.setTime, 1000);
  },
  methods: {
    initCharts() {
      // 初始化左边栏图表
      this.rightBottom = echarts.init(document.getElementById('rightBottomChart'));
      this.rightTop = echarts.init(document.getElementById('rightTopChart'));
      this.rightCenter = echarts.init(document.getElementById('rightCenterChart'));
      this.drawCharts();
    },
    drawCharts() {
      this.setChartOptions(this.rightBottom, this.getInspectionDefectOptions());
      this.setChartOptions(this.rightTop, this.getInspectionHistoryOptions());
      this.setChartOptions(this.rightCenter, this.getInspectionTodayOptions());
    },
    setChartOptions(chart, options) {
      chart.setOption(options);
    },
    getInspectionHistoryOptions() {
      return {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: 10,   // 左侧边距
          right: 0,  // 右侧边距
          top: 40,    // 顶部边距
          bottom: 0, // 底部边距
          containLabel: true // 是否包含坐标轴标签
        },
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: 'rgba(214, 214, 214, 0.3)', // 设置 X 轴颜色
            },
          },
        },
        yAxis: [
          {
            name:'(巡检活动)',
            nameTextStyle: {
              fontFamily: 'PingFang SC, PingFang SC-Medium',
              fontWeight: 500,
              textAlign: 'left',
              color: '#e6e6e6'
            },
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(214, 214, 214, 0.3)'
              }
            },
            axisLine: {
              show: false // 隐藏右侧 Y 轴的竖线
            },
            axisLabel: {
              color: '#ececec', // Y 轴文字颜色
            },
          },
        ],
        series: [
          {
            name: '飞行小时数(小时)',
            type: 'line',
            data: this.rightBottomData,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color:  '#FAC475'}, // 0% 透明色
                  { offset: 1, color:  '#FAC475' }, // 100% 不透明色
                ],
                global: false // 缺省为 false
              },
              borderColor: '#FAC475', // 边框颜色
              borderWidth: 2, // 边框宽度
              barBorderRadius: [10, 10, 0, 0],
            },
            emphasis: {
              focus: 'series',
              // 高亮时的数据点样式
              itemStyle: {
                color: '#fff',
              },
              // 高亮时的线条样式
              lineStyle: {
                width: 5,
                color: 'red'
              }
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(238,175,84,0.80)' },
                  { offset: 1, color: 'rgba(238,175,84,0.04)' }
                ]
              }
            },
            barWidth: '20%',
            smooth:true,
            // yAxisIndex: 1 // 指定使用右侧 Y 轴
            yAxisIndex: 0
          }
        ],
        textStyle: {
          color: '#FAC475' // 全局文字颜色
        }
      };
    },
    getInspectionTodayOptions() {
      return {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: 10,   // 左侧边距
          right: 0,  // 右侧边距
          top: 40,    // 顶部边距
          bottom: 0, // 底部边距
          containLabel: true // 是否包含坐标轴标签
        },
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: 'rgba(214, 214, 214, 0.3)', // 设置 X 轴颜色
            },
          },
        },
        yAxis: [
          {
            name: this.chartType === 'day' ? '(巡检小时数)' : this.chartType === 'frequency' ? '(巡检架次)' : '(巡检里程)',
            nameTextStyle: {
              fontFamily: 'PingFang SC, PingFang SC-Medium',
              fontWeight: 500,
              textAlign: 'left',
              color: '#e6e6e6'
            },
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(214, 214, 214, 0.3)'
              }
            },
            axisLine: {
              show: false // 隐藏右侧 Y 轴的竖线
            },
            axisLabel: {
              color: '#ececec', // Y 轴文字颜色
            },
          },
        ],
        series: [
          {
            name: '飞行小时数(小时)',
            type: 'line',
            data: this.rightBottomData,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color:  '#FAC475'}, // 0% 透明色
                  { offset: 1, color:  '#FAC475' }, // 100% 不透明色
                ],
                global: false // 缺省为 false
              },
              borderColor: '#FAC475', // 边框颜色
              borderWidth: 2, // 边框宽度
              barBorderRadius: [10, 10, 0, 0],
            },
            emphasis: {
              focus: 'series',
              // 高亮时的数据点样式
              itemStyle: {
                color: '#fff',
              },
              // 高亮时的线条样式
              lineStyle: {
                width: 5,
                color: 'red'
              }
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(255,140,77,0.80)' },
                  { offset: 1, color: 'rgba(255,140,77,0.04)' }
                ]
              }
            },
            barWidth: '20%',
            smooth:true,
            // yAxisIndex: 1 // 指定使用右侧 Y 轴
            yAxisIndex: 0
          }
        ],
        textStyle: {
          color: '#FAC475' // 全局文字颜色
        }
      };
    },
    getInspectionDefectOptions() {
      return {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          icon: 'circle',
          data: ['巡检缺陷(个)'],
          textStyle: {
            color: '#ececec',
          },
          itemStyle: {
            color: '#FF5649', // 设置图例图标颜色
          },
          itemGap: 15,
        },
        grid: {
          left: 20,   // 左侧边距
          right: 20,  // 右侧边距
          top: 40,    // 顶部边距
          bottom: 10, // 底部边距
          containLabel: true // 是否包含坐标轴标签
        },
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: 'rgba(214, 214, 214, 0.3)', // 设置 X 轴颜色
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(214, 214, 214, 0.3)'
              }
            },
            axisLine: {
              show: false // 隐藏右侧 Y 轴的竖线
            },
            axisLabel: {
              color: '#ececec', // Y 轴文字颜色
            },
          },
        ],
        series: [
          {
            name: '巡检缺陷(个)',
            type: 'bar',
            data: this.rightBottomData,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color:  'rgba(255, 86, 73, 0.68)'}, // 0% 透明色
                  { offset: 1, color:  'rgba(255, 86, 73, 0.14)' }, // 100% 不透明色
                ],
                global: false // 缺省为 false
              },
              borderColor: '#FF5649', // 边框颜色
              borderWidth: 2, // 边框宽度
              barBorderRadius: [10, 10, 0, 0],
            },
            barWidth: '20%',
            // yAxisIndex: 1 // 指定使用右侧 Y 轴
            yAxisIndex: 0
          }
        ],
        textStyle: {
          color: '#ececec' // 全局文字颜色
        }
      };
    },
    changeChartType(v){
      if(this.chartType !== v){
        this.chartType = v
        this.setChartOptions(this.rightCenter, this.getInspectionTodayOptions());
      }
    },
    setTime() {
      const d = new Date();
      const dStr = this.$moment(d).format("YYYY-MM-DD HH:mm:ss");
      const dStrArr = dStr.split(" ");
      this.$data.timeInfo.currentTime = dStrArr[1];
      this.$data.timeInfo.date = dStrArr[0];
      const day = d.getDay();
      const weeks = ["星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"];
      this.$data.timeInfo.weekday = weeks[day];
    },
    getFlightStatistics(){
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/statistics/flightStatistics").then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            this.rightBottomData = oData.data.xaxis.data.map((x, index) => [x, oData.data.series.data[index]])
            resolve()
          }
        });
      });

    },
    async getPageData(){
      await Promise.all([
        this.getFlightStatistics(),
      ]);
      this.initCharts()
    },
    handleResize() {
        this.rightTop.resize();
        this.rightBottom.resize();
        this.rightCenter.resize();
    },
  },
}
</script>

<style scoped>
@font-face {
  font-family: 'PangMenZhengDao-3';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

@font-face {
  font-family: 'PangMenZhengDao-3-Regular';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
#dashboardInspection {
  width: 100%;
  height: 100%;
}
.headerContent{
  width: 100%;
  height: 72px;
  background-image: url("../../assets/img/dashboard/system_header.png");
  background-size: 100%;
  display: flex;
  justify-content: space-between;
  padding: 16px 22px 0 17px;
  position: relative;
}
.headerLeft{
  display: flex;
}
.headerBtn{
  width: 120px;
  height: 40px;
  background-image: url("../../assets/img/dashboard/menu_btn.png");
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  text-shadow: 2px 2px 2px 2px rgba(0,0,0,0.18);
  line-height: 40px;
  cursor: pointer;
}
.headerMiddle{
  position: absolute;
  font-size: 44px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  letter-spacing: 2.64px;
  text-shadow: 2px 3.46px 3.68px 0.32px rgba(16,9,0,0.50);
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.headerRight{
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #f0f0f0;
  letter-spacing: 1.4px;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
  margin-top: 10px;
}
.contentWrap{
  position: relative;
  height: calc(100% - 72px);
}
.leftContent{
  background: rgba(16,10,1,0.78);
  height: 100%;
  //width: 20%;
  min-width: 400px;
  position: absolute;
  display: flex;
  left: 0;
}
.rightContent{
  right: 0;

}
.contentItem{
  flex: 33;
  min-height: 325px;
  display: flex;
  flex-direction: column;
}
.barChart{
  flex: 1;
  margin-top: 11px;
}
.labelContainer{
    position: absolute;
    height: 100%;
    width: 72px;
    border-right: 2px solid #685330;
}
.imgContainer{
    margin-top: 12px;
}
.lastImgContainer{
    position: absolute;
    bottom: 20px;
    transform: translateX(25%);
}
.infoContainer{
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
}
.titleContainer{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 327px;
    height: 56px;
    background: linear-gradient(0deg,rgba(255,190,93,0.68) 0%, rgba(255,190,93,0.00) 100%);
}
.title{
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
    padding-left: 15px;
}
.user{
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
    padding-right: 15px;
}
.airPortContainer{
    display: flex;
    flex-direction: column;
    height: 206px;
    padding: 14px;
    border-bottom: 2px solid #685330;
    /* align-items: center; */
}
.airport{
    display: flex;
    justify-content: space-between;
    line-height: 56px;
}
.txt{
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
}
.data{
    display: flex;
}
.num{
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    text-align: left;
    color: #ffbe5d;
    margin-right: 30px;
    }
.icon{
    width: 20px;
    height: 56px;
    background-image: url(../../assets/img/dashboard/zhan_kai.png);
    background-position: center center;
    background-repeat: no-repeat;
    margin-right: 15px;
    transform: scale(0.8,0.5);
}
.equipment{
    width: 294px;
    height: 116px;
    background: rgba(23,11,1,0.88);
    display: flex;
}
.state{
    flex:1;
}
.stateOne{
    width: 228px;
    height: 30px;
    background-color: #473116;
    margin-left: 10px;
    display: flex;
    padding-top: 5px;
    padding-left: 4px;
}
.stateTwo{
    width: 228px;
    height: 30px;
    background-color: #473116;
    margin-top: 10px;
    margin-left: 10px;
    display: flex;
    padding-top: 5px;
    padding-left: 4px;
}
.imgs{
    width: 48px;
    height: 116px;
    background-color: #473116;
    display: flex;
    justify-content: center;
    align-items: center;
}
.img-container{
    width: 24px;
    height: 24px;
    background-color: #473116;
    transform: scale(0.8,0.5);
}
.span{
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: left;
    color: #4ce8af;
    line-height: 20px;
    height: 20px;
    margin-left: 10px;
}
.onlineEquipment{
    padding: 0 14px;
    border-bottom: 2px solid #685330;
}
.internationalEquipmkent{
    padding: 0 14px;
    border-bottom: 2px solid #685330;
}
.rightContent{
    background: rgba(16,10,1,0.78);
    height: 100%;
    //width: 20%;
    min-width: 400px;
    position: absolute;
    display: flex;
    flex-direction: column;
    overflow: auto;
}
.rightContentItem{
    flex: 33;
    min-height: 325px;
    display: flex;
    flex-direction: column;
}
.itemTitle{
  height: 50px;
  background-image: url("../../assets/img/dashboard/pop_header.png");
  background-size: 100%;
  padding-left: 44px;
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
  margin-top: 12px;
}
.dataone-container{
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('../../assets/img/dashboard/shuju_bg2.png');
  background-size: cover;
  width: 350px;
  height: 92px;
  margin-left: 29px;
  margin-top: 10px;
}
.dataOne{
  padding: 14px;
  position: relative;
  border-right: 2px solid;
  border-image: linear-gradient(0deg, rgba(238,175,84,0.00), rgba(255,200,119,0.99) 49%, rgba(255,200,119,0.00)) 2 2;
}
.data{
  //margin-bottom: 5px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ebebeb;
}
.text{
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.checkData{
  border-bottom: 2px solid ;
  border-image: linear-gradient(0deg, rgba(255, 200, 119, 0.99), rgba(255, 200, 119, 0.00) 49%, rgba(238, 175, 84, 0.00)) 2 2;
  font-size: 30px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffc877;
  margin-bottom: 8px;
}
.inspectionContentWrap{
  padding: 23px 21px 0 29px;
  height: calc(100% - 50px);
}
#patrolHistory{
  background-image: url('../../assets/img/dashboard/shuju_bg2.png');
  width: 350px;
  height: 92px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
}
#patrolHistory .historyItem{
  width: 110px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 0 15px 0 15px;
}
#patrolHistory .historyItem:not(:last-child){
  border-right: 2px solid;
  border-image: linear-gradient(0deg, rgba(238,175,84,0.00), rgba(255,200,119,0.99) 49%, rgba(255,200,119,0.00)) 2 2;
}
.lineChartWrap{
  flex:1;
  height: calc(100% - 92px);
}
#patrolDefect{
  padding: 13px 23px 23px 34px;
  width: 350px;
  height: 92px;
  display: flex;
  justify-content: center;
  background-image: url('../../assets/img/dashboard/shuju_bg.png');
}
#patrolDefect .dayItem{
  width: 120px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 0 15px 0 15px;
}
.separate{
  border-right: 2px solid;
  border-image: linear-gradient(0deg, rgba(238,175,84,0.00), rgba(255,200,119,0.99) 49%, rgba(255,200,119,0.00)) 2 2;
}
.rightIconContainer{
  position: absolute;
  top:20px;
  right: 410px;
  width: 48px;
  height: calc(100% - 50px);
  background-color: #fff;
}
.iconContainer{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.topIconContainer{
  width: 100%;
  height: 100px;
}
.bottomIconContainer{
  width: 100%;
}
.top{
  margin-top: 10px;
}
*{
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/inspection.vue